import { Injectable } from '@angular/core';
import { IPaetepCfGenericMapperService } from '../../interfaces/paetep-cf-generic-mapper.service';
import { DropdownAnswerConfig } from 'src/app/model/observation/custom-forms/answer-configs/dropdown-answer-config.model';
import { EdlCfAnswerDropdownModel, EdlCfDropdownModel, EdlCfGenericModel, MAX_OPTION_LABEL_LENGTH, MAX_TITLE_LENGTH } from '@edl-development/edl-custom-forms';
import { CustomFormQuestionDisplayDTO } from 'src/app/model/observation/custom-forms/custom-form-question-dto.model';
import { CustomFormQuestionType } from 'src/app/model/enum/observations/custom-forms/custom-form-question-type.enum';
import { NumberValueSubAnswerConfig } from 'src/app/model/observation/custom-forms/answer-configs/sub-answer-configs/number-value-sub-answer-config.model';
import { OptionValueSubAnswerConfig } from 'src/app/model/observation/custom-forms/answer-configs/sub-answer-configs/option-value-sub-answer-config.model';
import { CustomFormsHelpersService } from '../../custom-forms-helpers/custom-forms-helpers.service';

@Injectable({
    providedIn: 'root'
})
export class PaetepCfDropdownMapperService implements IPaetepCfGenericMapperService<DropdownAnswerConfig, EdlCfDropdownModel<number | string>, string, EdlCfAnswerDropdownModel | null> {

    constructor(private customFormsHelpersService: CustomFormsHelpersService) { }

    public toEdlModel = (child: CustomFormQuestionDisplayDTO<DropdownAnswerConfig>): EdlCfDropdownModel<number | string> => {
        const options = child.answerConfig?.optionValues?.map((o, index) => {
            const numberValue = (child.answerConfig?.numberValues ?? [])[index]?.numberValue;
            return {
                id: this.customFormsHelpersService.getOptionId(child, index),
                label: o.optionValue,
                value: (numberValue != null && numberValue != undefined) ? Number(numberValue) : o.optionValue
            }
        }) ?? [];

        return {
            title: child.label,
            isRequired: child.required,
            hasSelectNullOption: false,
            options
        }
    }

    public toPaetepModel = ({
        formID, 
        sectionID,
        displayOrder,
        groupOrder,
        question
    } : {
        formID: string, 
        sectionID: string, 
        displayOrder: number,
        groupOrder: number,
        question: EdlCfGenericModel<EdlCfDropdownModel<number | string>>
    }): CustomFormQuestionDisplayDTO<DropdownAnswerConfig> =>  {
        const optionValues: OptionValueSubAnswerConfig[] = question.config.options.map(o => {
            return {
                optionValue: (o.label ?? '').substring(0, MAX_OPTION_LABEL_LENGTH)
            }
        });
        const numberValues: NumberValueSubAnswerConfig[] = question.config.options.map(o => {
                return {
                    numberValue: `${o.value}`
                }
        });
        
        return this.customFormsHelpersService.createCustomFormQuestion<DropdownAnswerConfig>({
            $type: CustomFormQuestionType.DROPDOWN,
            typeID: CustomFormQuestionType.DROPDOWN,
            formID,
            sectionID,
            questionID: question?.id ?? '',
            readOnly: false,
            required: question.config.isRequired,
            displayOrder,
            groupOrder,
            label: (question?.config?.title ?? '').substring(0, MAX_TITLE_LENGTH),
            displayLabel: true,
            answerConfig: {
                optionValues,
                numberValues
            }
        });
    }

    public toEdlAnswer = (answer: string = '', question: CustomFormQuestionDisplayDTO<DropdownAnswerConfig>) => {
        const optionValues: string[] = question.answerConfig?.optionValues?.map(o => o.optionValue) ?? [];
        const valueIndex = optionValues.findIndex(o => o == answer);

        return valueIndex < 0 ? null : this.customFormsHelpersService.getOptionId(question, valueIndex);
    }

    public toPaetepAnswer = (answer: EdlCfAnswerDropdownModel | null | undefined, question: CustomFormQuestionDisplayDTO<DropdownAnswerConfig>) => {
        const optionValueIndex = this.customFormsHelpersService.getOptionIndexFromId(answer);
        return question.answerConfig?.optionValues?.[optionValueIndex]?.optionValue;
    }
}
